export default __webpack_public_path__ + "static/media/wbuy.85d32ab9.png";